module.exports = __webpack_public_path__ + "media/images/old_logos/logo-968f499b9c1384b7f53a4fd00c5a16f1.svg";